module.exports = __webpack_public_path__ + "static/sanusi-b8c2f4b1c840b27f9ff12d24af69ccab.jpg";